
import React from 'react'
import { Typography, Input, Row, Col, Form, Card, Button, Select } from 'antd'
import PropTypes from 'prop-types'
import { ImageUploader } from '~components'
import styles from './HorizontalBanner.module.css'

const { Title } = Typography

const HorizontalBanner = ({ horizontalBanner, setHorizontalBanner }) => {
  const handleIconChange = (idx, imageObj) => {
    console.log(imageObj)
    const updatedImages = (horizontalBanner.images || []).map((img, i) =>
      i === idx ? { ...img, ...imageObj } : img
    )
    setHorizontalBanner && setHorizontalBanner({ ...horizontalBanner, images: updatedImages })
  }

  const handleImageUrlUpdate = (idx, imageUrl) => {
    const updatedImages = (horizontalBanner.images || []).map((img, i) =>
      i === idx ? { ...img, url: imageUrl } : img
    )
    setHorizontalBanner && setHorizontalBanner({ ...horizontalBanner, images: updatedImages })
  }
  const handleCTAUrlChange = ({ target }) => {
    setHorizontalBanner && setHorizontalBanner({ ...horizontalBanner, cta_url: target.value })
  }

  const handleAddImage = () => {
    setHorizontalBanner && setHorizontalBanner({
      ...horizontalBanner,
      images: [...(horizontalBanner.images || []), { url: '', alt: '' }]
    })
  }

  const handleRemoveImage = (idx) => {
    setHorizontalBanner && setHorizontalBanner({
      ...horizontalBanner,
      images: (horizontalBanner.images || []).filter((_, i) => i !== idx)
    })
  }

  const handleImageChange = (idx, field, value) => {
    const updatedImages = (horizontalBanner.images || []).map((img, i) =>
      i === idx ? { ...img, [field]: value } : img
    )
    setHorizontalBanner && setHorizontalBanner({ ...horizontalBanner, images: updatedImages })
  }

  return (
    <div className={styles['horizontal-banner-container']}>
      <Card className={ styles['card-container'] }>
        <Row align={'left'} className={styles['title-wrapper']} gutter={[10, 10]}>
          <Col><Title level={3}>Call-to-Action URL*</Title></Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Form.Item><Input onChange={handleCTAUrlChange} value={horizontalBanner?.cta_url}/></Form.Item>
          </Col>
        </Row>
        <Row gutter={[10, 10]} style={{ marginTop: 24 }}>
          <Col span={24}>
            <Col gutter={[24, 24]}>
              {(horizontalBanner.images || []).map((img, idx) => (
                <Col key={idx} md={8} sm={12} style={{ border: '1px solid #001529', borderRadius: 8, margin: 16, padding: 16, height: '100%', minWidth: '512px' }} xs={24}>
                  <div style={{ margin: 16, padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                      <Select
                        onChange={value => handleImageChange(idx, 'type', value)}
                        placeholder="Select Image Type"
                        style={{ width: '180px', marginRight: 8 }}
                        value={img.type || undefined}
                      >
                        {['desktop', 'mobile', 'tablet'].filter(type => {
                          // Always show the current value for this item, and hide types already selected in other items
                          if (img.type === type) return true
                          return !(horizontalBanner.images || []).some((otherImg, otherIdx) => otherIdx !== idx && otherImg.type === type)
                        }).map(type => (
                          <Select.Option key={type} value={type}>
                            {type.charAt(0).toUpperCase() + type.slice(1)}
                          </Select.Option>
                        ))}
                      </Select>
                      <Button className={styles.deleteActionButton} onClick={() => handleRemoveImage(idx)} style={{ backgroundColor: '#DA0D50', color: '#fff', marginRight: 8 }} type='danger'>
                        Remove
                      </Button>
                    </div>
                    <ImageUploader
                      alt={img.alt}
                      handleIconChange={imageObj => handleIconChange(idx, imageObj)}
                      handleUpload={imageUrl => handleImageUrlUpdate(idx, imageUrl)}
                      logoUrl={img.url}
                    />
                  </div>
                </Col>
              ))}
            </Col>
            <Button
              disabled={(horizontalBanner.images || []).length >= 3}
              onClick={handleAddImage}
              style={{ marginTop: 8 }}
              type="button"
            >
              Add Image
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  )
}

HorizontalBanner.propTypes = {
  horizontalBanner: PropTypes.array,
  setHorizontalBanner: PropTypes.func
}

export default HorizontalBanner
